// extracted by mini-css-extract-plugin
export default {"toast":"App_toast__9gxzU","icon":"App_icon__W1LYv"};